import { useEffect } from 'react'
import { urlTracking } from './custom'

interface LocationProps {
  latitude?: string
  longitude?: string
}

export const useTracking = () => {
  const checkGeoLocationPermission = async (): Promise<boolean> => {
    if (navigator.permissions) {
      const result = await navigator.permissions.query({ name: 'geolocation' })
      if (result.state === 'granted') {
        return true
      }
    }
    return false
  }

  useEffect(() => {
    const getLocation = async (): Promise<LocationProps> => {
      const isGeoLocationAccessAllowed = await checkGeoLocationPermission()
      if (isGeoLocationAccessAllowed) {
        if (typeof navigator !== 'undefined' && navigator.geolocation) {
          return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                const latitude = position.coords.latitude.toString()
                const longitude = position.coords.longitude.toString()
                resolve({ latitude, longitude })
              },
              (error) => {
                resolve({})
              },
            )
          })
        } else {
          console.error('Geolocation is not supported by this browser.')
          return {}
        }
      }
      return {}
    }
    const tracking = async (locationProps: LocationProps) => {
      await fetch(urlTracking, {
        method: 'POST',
        body: JSON.stringify(locationProps),
        headers: {
          'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
          'X-Authorization': `${localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`)}`,
          'X-Local': localStorage.getItem('i18nextLng'),
        },
      })
    }
    getLocation().then((v) => tracking(v))
  }, [])
}
